<p-dialog [(visible)]="dialogVisible" (visibleChange)="onVisibleChange($event)" 
  [header]="template ? ('i18n.domain.product-template.overview.edit-dialog-title' | translate) : ('i18n.domain.product-template.overview.create-dialog-title' | translate)"
  [modal]="true" [style]="{ width: '60vw' }" [breakpoints]="{ '960px': '75vw', '640px': '90vw' }">

  <form [formGroup]="form" (ngSubmit)="onSave()">
    <div class="p-fluid">
      <!-- Images Section (at top) -->
      <div class="images-section">
        <h4 class="section-title">{{ 'i18n.domain.product-template.form.product-images' | translate }}</h4>
        
        <!-- Existing images (when editing) -->
        <div *ngIf="existingImages && existingImages.length > 0" class="existing-images">
          <label class="current-images-label">{{ 'i18n.domain.product-template.form.current-images' | translate }}:</label>
          <div class="images-container">
            <div *ngFor="let img of existingImages; let i = index" class="image-wrapper">
              <img [src]="img.imageUrl" 
                alt="Current" 
                class="image-preview"
                [class.primary]="img.isPrimary"
                (click)="setPrimaryExistingImage(i)"
                title="Click to set as primary" />
              <button type="button" pButton icon="pi pi-trash" class="p-button-sm p-button-danger delete-btn"
                (click)="removeExistingImage(i)"></button>
            </div>
            <div class="add-image-wrapper">
              <input type="file" #fileInput hidden (change)="onImageSelected($event)" accept="image/*" />
              <button type="button" pButton icon="pi pi-plus" class="p-button-rounded p-button-outlined add-btn"
                (click)="fileInput.click()" title="Add image">
                <span class="add-text">{{ 'i18n.domain.product-template.form.add-images' | translate }}</span>
              </button>
            </div>
          </div>
        </div>

        <!-- New images upload (when creating) -->
        <div *ngIf="!existingImages || existingImages.length === 0" class="image-upload-section">
          <div class="images-container">
            <div *ngFor="let img of templateImages; let i = index" class="image-wrapper">
              <img [src]="img.imageUrl" 
                alt="New" 
                class="image-preview"
                [class.primary]="img.isPrimary"
                (click)="setPrimaryImage(i)" 
                title="Click to set as primary" />
              <button type="button" pButton icon="pi pi-trash" class="p-button-sm p-button-danger delete-btn"
                (click)="removeImage(i)"></button>
            </div>
            <div class="add-image-wrapper">
              <input type="file" #fileInput hidden (change)="onImageSelected($event)" accept="image/*" />
              <button type="button" pButton icon="pi pi-plus" class="p-button-rounded p-button-outlined add-btn"
                (click)="fileInput.click()" title="Add image">
                <span class="add-text">{{ 'i18n.domain.product-template.form.add-images' | translate }}</span>
              </button>
            </div>
          </div>
          <div *ngIf="templateImages.length > 0" class="image-list">
            <div *ngFor="let img of templateImages; let i = index" class="image-item">
              <span>{{ i + 1 }}. {{ img.imageUrl?.split('/').pop() }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Quick Entry Section: Essential Fields Only -->
      <div class="quick-entry-section">
        <h4 class="section-title">{{ 'i18n.domain.product-template.form.essential-info' | translate }}</h4>
        
        <div class="grid">
          <div class="col-12 md:col-8">
            <div class="field">
              <label for="templateName">{{ 'i18n.domain.product-template.fields.template-name' | translate }} *</label>
              <input pInputText id="templateName" type="text" formControlName="templateName" 
                placeholder="e.g., Premium Wireless Headphones" />
            </div>
          </div>
          <div class="col-12 md:col-4">
            <div class="field">
              <label for="price">{{ 'i18n.domain.product-template.fields.price' | translate }} *</label>
              <input pInputText id="price" type="number" formControlName="price" 
                placeholder="0.00" />
            </div>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 md:col-6">
            <div class="field">
              <label for="categoryIds">{{ 'i18n.domain.product-template.fields.categories' | translate }} *</label>
              <p-multiSelect id="categoryIds" formControlName="categoryIds" [options]="categories"
                optionLabel="name" optionValue="id" [showToggleAll]="false" 
                placeholder="Select categories"></p-multiSelect>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="field">
              <label for="quantity">{{ 'i18n.domain.product-template.fields.default-quantity' | translate }} *</label>
              <input pInputText id="quantity" type="number" formControlName="quantity" 
                placeholder="10" />
            </div>
          </div>
        </div>
      </div>

      <!-- Description Section -->
      <div class="description-section">
        <h4 class="section-title">{{ 'i18n.domain.product-template.form.details' | translate }}</h4>
        <div class="field">
          <label for="description">{{ 'i18n.domain.product-template.fields.description' | translate }}</label>
          <textarea pInputTextarea id="description" formControlName="description" rows="2" maxlength="300"

            placeholder="Brief product description..."></textarea>

            <small class="char-count">
            {{ form.get('description')?.value?.length || 0 }}/300
          </small>

        </div>
      </div>

      <!-- Delivery & Listing Section -->
      <div class="delivery-section">
        <h4 class="section-title">{{ 'i18n.domain.product-template.form.delivery-listing' | translate }}</h4>
        <div class="grid">
          <div class="col-6">
            <div class="field">
              <label for="deliveryOption">{{ 'i18n.domain.product-template.fields.delivery-option' | translate }}</label>
              <p-dropdown id="deliveryOption" formControlName="deliveryOption" [options]="deliveryOptions"
                optionLabel="label" optionValue="value" placeholder="Select"></p-dropdown>
            </div>
          </div>
          <div class="col-6">
            <div class="field">
              <label for="daysToUnlist">{{ 'i18n.domain.product-template.fields.days-to-unlist' | translate }} *</label>
              <input pInputText id="daysToUnlist" type="number" formControlName="daysToUnlist" 
                placeholder="30" />
            </div>
          </div>
        </div>
      </div>

      <!-- Unit Information Section (Collapsible) -->
      <div class="unit-section">
        <h4 class="section-title">{{ 'i18n.domain.product-template.form.unit-info' | translate }}</h4>
        <div class="grid">
          <div class="col-4">
            <div class="field">
              <label for="unitValue">{{ 'i18n.domain.product-template.fields.unit-value' | translate }}</label>
              <input pInputText id="unitValue" type="number" formControlName="unitValue" 
                placeholder="1" />
            </div>
          </div>
          <div class="col-4">
            <div class="field">
              <label for="unitType">{{ 'i18n.domain.product-template.fields.unit-type' | translate }}</label>
              <p-dropdown id="unitType" formControlName="unitType" [options]="unitTypeOptions"
                optionLabel="label" optionValue="value" placeholder="Select"></p-dropdown>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-6">
            <div class="field">
              <label for="unitCategory">{{ 'i18n.domain.product-template.fields.unit-category' | translate }}</label>
              <p-dropdown id="unitCategory" formControlName="unitCategory" [options]="unitCategoryOptions"
                optionLabel="label" optionValue="value" placeholder="Select"></p-dropdown>
            </div>
          </div>
        </div>
      </div>

      <!-- Additional Info Section -->
      <div class="additional-section">
        <h4 class="section-title">{{ 'i18n.domain.product-template.form.additional-info' | translate }}</h4>
        <div class="field">
          <label for="additionalInfo">{{ 'i18n.domain.product-template.fields.notes' | translate }}</label>
          <textarea pInputTextarea id="additionalInfo" formControlName="additionalInformation" rows="2"
          maxlength="300"
            placeholder="Any additional details..."></textarea>

            <small class="char-count">
            {{ form.get('additionalInformation')?.value?.length || 0 }}/300
          </small>


        </div>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="{{ 'i18n.shared.cancel' | translate }}" icon="pi pi-times"
      class="p-button-text" (click)="onCancel()"></button>
    <button pButton type="button" label="{{ 'i18n.domain.product-template.form.save-template' | translate }}" icon="pi pi-check"
      [disabled]="!form.valid" class="p-button-success" (click)="onSave()"></button>
  </ng-template>
</p-dialog>
